import { UseFormRegisterReturn } from 'react-hook-form'

type Props = {
  disabled?: boolean
  value?: string
  register?: UseFormRegisterReturn<'memo'>
  placeHolder?: string
}
export const Memo = (props: Props): JSX.Element => {
  const { disabled, value, register, placeHolder = '' } = props
  const commonStyle =
    'block w-full min-h-[300px] rounded border border-[#ddd] p-3 text-sm font-inherit resize-y outline-none'

  return register ? (
    <textarea {...register} className={commonStyle} placeholder={placeHolder} />
  ) : (
    <textarea value={value} className={commonStyle} disabled={disabled} />
  )
}
